import NewSalesOrder from "../../../../components/@documents/sales_orders/NewSalesOrder";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SalesOrderNewPage() {

    return (
        <NewSalesOrder 
            routeType={routeTypes.retail}
        />
    )
}